export var fontFamily = 'Helvetica, Arial, sans-serif';
export var circularFontFamily = 'AxLLCircular, Helvetica, Arial, sans-serif';
export var dinFontFamily = circularFontFamily;
export { default as injectGlobalFonts } from './static/fonts';